<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.sa_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="sa_vendname">
            <label class="weui-form-preview__label">{{
              customLabel.sa_vendname || "供应商"
            }}</label>
            <em class="weui-form-preview__value">{{
              form.main.sa_vendname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="sa_date">
            <label class="weui-form-preview__label">{{
              customLabel.sa_date || "送样日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.sa_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="sa_man">
            <label class="weui-form-preview__label">{{
              customLabel.sa_man || "送样人"
            }}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
            >
              {{ form.main.sa_man }}
              {{ form.main.sa_tel }}
              <call-mobile :mobile="form.main.sa_tel"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="sa_send_times">
            <label class="weui-form-preview__label">{{
              customLabel.sa_send_times || "送样次数"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.sa_send_times
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="sa_qty">
            <label class="weui-form-preview__label">{{
              customLabel.sa_qty || "送样数量"
            }}</label>
            <span class="weui-form-preview__value">{{ form.main.sa_qty }}</span>
          </div>
          <div class="weui-form-preview__item" slot="sa_reason">
            <label class="weui-form-preview__label">{{
              customLabel.sa_reason || "送样原因"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.sa_reason
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="sa_attach_refs">
            <label class="weui-form-preview__label">{{
              customLabel.sa_attach_refs || "附属资料"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.sa_attach_refs
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{
              customLabel.pr_detail || "样品名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_detail
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_manutype">
            <label class="weui-form-preview__label">{{
              customLabel.pr_manutype || "生产类型"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_manutype
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_kind">
            <label class="weui-form-preview__label">{{
              customLabel.pr_kind || "物料类型"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_kind
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_code">
            <label class="weui-form-preview__label">{{
              customLabel.pr_code || "样品料号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_code
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{
              customLabel.pr_orispeccode || "型号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_orispeccode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_spec">
            <label class="weui-form-preview__label">{{
              customLabel.pr_spec || "规格"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_spec
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_brand">
            <label class="weui-form-preview__label">{{
              customLabel.pr_brand || "厂家/品牌"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_brand
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_unit">
            <label class="weui-form-preview__label">{{
              customLabel.pr_unit || "库存单位"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_unit
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.sd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{
                customLabel.sd_item || "检查项目"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_item }}
              </span>
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.sd_standard"
              slot="sd_standard"
            >
              <label class="weui-form-preview__label">{{
                customLabel.sd_standard || "检查标准"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_standard }}
              </span>
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.sd_checkqty"
              slot="sd_checkqty"
            >
              <label class="weui-form-preview__label">{{
                customLabel.sd_checkqty || "抽样数量"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_checkqty }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sd_okqty">
              <label class="weui-form-preview__label">{{
                customLabel.sd_okqty || "合格数量"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_okqty }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sd_ngqty">
              <label class="weui-form-preview__label">{{
                customLabel.sd_ngqty || "不合格数量"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_ngqty }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sd_nk_reason_array">
              <label class="weui-form-preview__label">{{
                customLabel.sd_nk_reason_array || "不良现象"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_nk_reason_array }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sd_result">
              <label class="weui-form-preview__label">{{
                customLabel.sd_result || "检验结果"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_result }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sd_sample1">
              <label class="weui-form-preview__label">{{
                customLabel.sd_sample1 || "样本1"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_sample1 }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sd_sample2">
              <label class="weui-form-preview__label">{{
                customLabel.sd_sample2 || "样本2"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_sample2 }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sd_sample3">
              <label class="weui-form-preview__label">{{
                customLabel.sd_sample3 || "样本3"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_sample3 }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sd_sample4">
              <label class="weui-form-preview__label">{{
                customLabel.sd_sample4 || "样本4"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_sample4 }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sd_sample5">
              <label class="weui-form-preview__label">{{
                customLabel.sd_sample5 || "样本5"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_sample5 }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sd_sample6">
              <label class="weui-form-preview__label">{{
                customLabel.sd_sample6 || "样本6"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_sample6 }}
              </span>
            </div>

            <div class="weui-form-preview__item" slot="sd_sample7">
              <label class="weui-form-preview__label">{{
                customLabel.sd_sample7 || "样本7"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_sample7 }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sd_sample8">
              <label class="weui-form-preview__label">{{
                customLabel.sd_sample8 || "样本8"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_sample8 }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sd_sample9">
              <label class="weui-form-preview__label">{{
                customLabel.sd_sample9 || "样本9"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_sample9 }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sd_sample10">
              <label class="weui-form-preview__label">{{
                customLabel.sd_sample10 || "样本10"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.sd_sample10 }}
              </span>
            </div>
          </custom-layout>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="rd_result">
            <label class="weui-form-preview__label">{{
              customLabel.rd_result || "研发验证结果"
            }}</label>
            <em class="weui-form-preview__value">{{ form.main.rd_result }}</em>
          </div>
          <div class="weui-form-preview__item" slot="rd_emname">
            <label class="weui-form-preview__label">{{
              customLabel.rd_emname || "研发验证人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.rd_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="rd_date">
            <label class="weui-form-preview__label">{{
              customLabel.rd_date || "研发验证日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.rd_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="rd_remark">
            <label class="weui-form-preview__label">{{
              customLabel.rd_remark || "研发验证说明"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.rd_remark
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="eng_result">
            <label class="weui-form-preview__label">{{
              customLabel.eng_result || "工程验证结果"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.eng_result
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="eng_emname">
            <label class="weui-form-preview__label">{{
              customLabel.eng_emname || "工程验证人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.eng_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="eng_date">
            <label class="weui-form-preview__label">{{
              customLabel.eng_date || "工程验证日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.eng_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="eng_remark">
            <label class="weui-form-preview__label">{{
              customLabel.eng_remark || "工程验证说明"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.eng_remark
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qa_result">
            <label class="weui-form-preview__label">{{
              customLabel.qa_result || "品质验证结果"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.qa_result
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qa_emname">
            <label class="weui-form-preview__label">{{
              customLabel.qa_emname || "品质验证人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.qa_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qa_date">
            <label class="weui-form-preview__label">{{
              customLabel.qa_date || "品质验证日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.qa_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qa_remark">
            <label class="weui-form-preview__label">{{
              customLabel.qa_remark || "品质验证说明"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.qa_remark
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="sa_final_conclusion">
            <label class="weui-form-preview__label">{{
              customLabel.sa_final_conclusion || "确认结论"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.sa_final_conclusion
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="sa_final_basis">
            <label class="weui-form-preview__label">{{
              customLabel.sa_final_basis || "确认依据"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.sa_final_basis
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="sa_improvement">
            <label class="weui-form-preview__label">{{
              customLabel.sa_improvement || "改进"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.sa_improvement
            }}</span>
          </div>
        </custom-layout>
      </div>

      <file-list v-model="form.main.sa_attach" />
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile,
  },
  data() {
    return {
      baseUrl: "/api/plm/sample",
      codeField: "sa_code",
      statusField: "sa_statuscode",
      caller: "PlmSample",
      xtype: "plm-sample-formpanel",
    };
  },
};
</script>